import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { IProjectActions } from '../types/IProjectActions';

export class GetProjectActionsRequest extends Request<ISingleIdParams, IProjectActions> {
  constructor(id: string) {
    super('getProjectActions', { id: id });
  }
}
